<ng-container *ngIf="integration">
    <ng-container
        *ngIf="'import.integrations.providers.' + integration.name.toUpperCase() | translate as integrationName"
    >
        <div class="header">
            <app-header
                [title]="'import.integrations.steps.connect.subtitle' | translate: { integrationName }"
                [subtitle]="'import.integrations.steps.connect.description' | translate: { integrationName }"
                [back]="true"
                [onBackClick]="onBack.bind(this)"
            />
            <a href="{{ integrationsHelpLink }}" target="_blank"
                ><mat-icon svgIcon="help" />{{ 'import.integrations.help' | translate }}</a
            >
        </div>
        <ui-banner *ngIf="isErrored" variant="danger">
            {{ 'import.integrations.steps.connect.URLError' | translate: { integrationName } }}
        </ui-banner>
        <div class="content-container">
            <div class="connection-details" [class.loading]="!connectionURL && !isErrored" [class.errored]="isErrored">
                <div class="connection-partner">
                    <div class="logo">
                        <img [src]="integration.logo" />
                    </div>
                    <h3>
                        <a target="_blank" [href]="integration.integrationURL">{{ integrationName }}</a>
                    </h3>
                </div>
                <div class="connection-fields">
                    <div>{{ 'import.integrations.steps.connect.fields' | translate: { integrationName } }}</div>
                    <div class="fields-list">
                        <ui-badge type="primary" *ngFor="let field of VISIBLE_FIELDS">
                            {{ 'import.integrations.steps.connect.fieldTypes.' + field | translate }}</ui-badge
                        >
                    </div>
                </div>
            </div>
            <ui-button
                type="primary"
                [disabled]="!connectionURL"
                [url]="connectionURL ?? ''"
                [externalLink]="true"
                [openInNewTab]="false"
                ><mat-icon svgIcon="link" />{{ 'settings.integration-card.connectButton' | translate }}</ui-button
            >
            <mat-accordion *ngIf="connectionURL">
                <mat-expansion-panel class="borderless">
                    <mat-expansion-panel-header class="link" collapsedHeight="24px" expandedHeight="24px">
                        <a>{{ 'import.integrations.steps.connect.help.label' | translate }}</a>
                    </mat-expansion-panel-header>
                    <ui-card class="instructions" variant="outline" [withMargin]="false">
                        <ul *ngIf="sanitizedConnectionInstructions?.length">
                            <li
                                *ngFor="let instruction of sanitizedConnectionInstructions"
                                [innerHtml]="instruction | sanitizeHtml"
                            ></li>
                        </ul>
                        <div class="centered">
                            {{ 'import.integrations.steps.connect.help.documentation.label' | translate
                            }}<a target="_blank" [href]="integration.documentationURL">
                                {{
                                    'import.integrations.steps.connect.help.documentation.link'
                                        | translate: { integrationName }
                                }}
                            </a>
                        </div>
                    </ui-card>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </ng-container>
</ng-container>
